import { useQueryClient } from '@tanstack/react-query';
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';

import {
  useCreateQrChallenge,
  useQrCodeLink,
  useSolveQrChallenge,
} from '../../../../shared/hooks/linkHook';
import { SlotRef } from '../../common/components/Slot/types';
import { PreviewVerification } from '../Preview/Verification';

interface QrCodeVerificationProps {
  setSessionId(sessionID: string): void; //verified answer ID
  setSessionEndAt(sessionEndAt: string): void; // 1hour
}
export const QrCodeVerification = ({
  setSessionId,
  setSessionEndAt,
}: QrCodeVerificationProps) => {
  const client = useQueryClient();

  const { id = '' } = useParams();
  const [failure, setFailure] = useState(0);
  const [challengeId, setChallengeId] = useState(''); //verified answer ID

  const birthInput = useRef<SlotRef>(null);

  // 실패횟수, 30일기한 GET
  const { data: link } = useQrCodeLink(id);
  useEffect(() => {
    if (link) {
      setFailure(link.failureCount);
    }
  }, [link]);

  //챌린지생성
  const { mutate: createChallenge } = useCreateQrChallenge({
    onSuccess: challengeData => {
      setChallengeId(challengeData.id);
      const timeDiff = timeDiffwithCurrentInHours(challengeData.endAt);
      if (challengeData.isPassed && timeDiff >= 1) {
        setSessionId('');
      }
    },
    onError: (error, variables, context) => {
      console.log('error, variables, context : ', error, variables, context);
    },
  });

  //정답체크
  const { mutate: solveQrChallenge } = useSolveQrChallenge({
    onSuccess: challengeData => {
      setSessionId(challengeData.id);
      setSessionEndAt(challengeData.endAt);
      setFailure(0);
    },
    onError: (error, variables, context) => {
      console.log('error, variables, context : ', error, variables, context);
      client.invalidateQueries({ queryKey: ['QrCodeLink', id] }).then(() => {
        birthInput.current?.inputs[0]?.focus();
      });
    },
  });

  useEffect(() => {
    // wait for setting csrf-token
    if (link) {
      createChallenge(id);
    }
  }, [id, createChallenge, link]);

  const timeDiffwithCurrentInHours = (date: string) => {
    return (+new Date(date) - Date.now()) / (60 * 60 * 1000);
  };

  return (
    <PreviewVerification
      failure={failure}
      birthInput={birthInput}
      onAnswer={(birth, gender) => {
        solveQrChallenge({
          uri: id,
          id: challengeId,
          birth,
          gender,
        });
      }}
    />
  );
};
